// Package Imports
import React from 'react';
import { Form, Input } from 'antd';

// Project Imports
import regex from 'core/constants/Regex';
import { TextInputProps } from 'components/text/type';
import classNames from 'core/utils/classNames';

const TextInput = ({
  label,
  name,
  required,
  onChange,
  defaultValue,
  style,
  disabled,
  rules,
  placeholder,
  message,
  onlyChars,
  size = 'middle',
  variant,
  textClass,
  labelClass,
  value,
}: TextInputProps) =>
  typeof name === 'string' || Array.isArray(name) ? (
    <div
      className={
        classNames(
          disabled
            ? 'floating-disabled relative custom-border'
            : 'relative custom-border',
          size === 'small' ? 'element-sm' : 'element-normal'
        )
        // disabled
        //   ? 'floating-disabled relative custom-border'
        //   : 'relative custom-border'
      }
    >
      <label className={`floating-label ${labelClass}`}>
        {label} {required ? <span className="a8-error">*</span> : null}
      </label>
      <Form.Item
        name={typeof name === 'string' ? [name] : name}
        rules={[
          { ...rules },
          {
            pattern: regex.noTags,
            message: 'Input must not contain HTML or XML tags.',
          },
          {
            required,
            ...(onlyChars ? { pattern: regex.charsCheck } : {}),
            message,
          },
        ]}
        hasFeedback={required || !!value}
        style={style}
      >
        <Input
          size={size}
          className={`${textClass} ${size === 'small' ? 'py-sm ' : 'py-3 '}`}
          disabled={disabled}
          onChange={onChange}
          placeholder={placeholder}
          variant={variant}
        />
      </Form.Item>
    </div>
  ) : (
    <div className={disabled ? 'floating-disabled relative' : 'relative '}>
      <label className="floating-label custom-border">
        {label} {required ? <span className="a8-error">*</span> : null}
      </label>
      <Input
        size={size}
        className={size === 'small' ? 'py-sm' : 'py-3'}
        disabled={disabled}
        placeholder={label}
        onChange={onChange}
        defaultValue={defaultValue}
      />
    </div>
  );

export default TextInput;
